import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { locationService } from "@project/services/admin/location.service";
import type { Area } from "@project/types/location";

const fields: Field[] = [
  {
    name: "city",
    label: "City",
    required: true,
    showInTable: true,
    lookup: { table: "cities", labelField: "name" },
  },
  {
    name: "name",
    label: "Area Name",
    required: true,
    showInTable: true,
    placeholder: "Satellite",
  },
  { name: "is_active", label: "Active", type: "boolean", showInTable: true },
];

export default function Page() {
  return (
    <AdminShell title="Areas" subtitle="Manage areas linked to cities">
      <ApiResourceTable<Area>
        title="Area"
        fields={fields}
        searchFields={["name"]}
        defaultValues={{ is_active: true }}
        lookupSearchLoaders={{
          city: async query => {
            const result = await locationService.listCitiesPage({
              page: 1,
              page_size: 50,
              search: query || undefined,
            });
            return result.data.map(c => ({
              value: String(c.id),
              label: c.name,
              secondary: c.district_name,
            }));
          },
        }}
        list={query => locationService.listAreasPage(query)}
        create={payload =>
          locationService.createArea({
            city: Number(payload.city),
            name: String(payload.name),
            is_active: Boolean(payload.is_active),
          })
        }
        update={(id, payload) =>
          locationService.updateArea(id, {
            city: payload.city !== undefined ? Number(payload.city) : undefined,
            name: payload.name !== undefined ? String(payload.name) : undefined,
            is_active:
              payload.is_active !== undefined
                ? Boolean(payload.is_active)
                : undefined,
          })
        }
        remove={id => locationService.deleteArea(id)}
      />
    </AdminShell>
  );
}
